import { render, staticRenderFns } from "./select2.editor.vue?vue&type=template&id=54873433&"
import script from "./select2.editor.vue?vue&type=script&lang=ts&"
export * from "./select2.editor.vue?vue&type=script&lang=ts&"
import style0 from "./select2.editor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports